module.exports = __webpack_public_path__ + "img/500.e05f32a7.png";